export enum PaymentVerifiedStatusEnum {
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
  NOT_STARTED = 'NOT_STARTED',
  NOT_STARTED_MISSING_DATA = 'NOT_STARTED_MISSING_DATA'
}